import ActivityFeed from '@app/components/ActivityFeed'
import FeedItemEditor from '@app/components/FeedItemEditor'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'

export default class Home extends React.Component<RouteComponentProps<{}>, {}> {
  public render() {
    return (
      <DocumentTitle title='Home'>
        <div className='container d-flex flex-column h-100 mt-3'>
          <FeedItemEditor />
          <div className='flex-grow-1'>
            <ActivityFeed />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}
